import { Heart } from 'lucide-react';

export const EnhancedFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-enhanced">
      <div className="footer-content">
        <div className="footer-logo-section">
          <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Logo" className="footer-logo" width="120" height="120" loading="lazy" />
        </div>
        <div className="footer-text">
          <span>Εξάσκηση στις ερωτήσεις πιστοποίησης</span>
          <span className="footer-divider">•</span>
          <span className="footer-author">
            Made with <Heart className="heart-icon" fill="currentColor" /> by 
            <a href="https://j-patch.info" target="_blank" rel="noopener noreferrer" className="footer-logo-link">
              <img src={`${process.env.PUBLIC_URL}/logo-dark-1.webp`} alt="J.Patch" className="footer-author-logo" width="63" height="28" loading="lazy" />
            </a>
          </span>
          <span className="footer-divider">•</span>
          <span>© {currentYear}</span>
        </div>
      </div>
    </footer>
  );
};
